.ds-sidebar {
  position: fixed;
  transition: transform ease 0.4s;
  background: #fff;

  &__content {
    /* overflow-x: auto;
    overflow-y: hidden; */
  }
  
  &.--shown {
    transform: translate3d(0,0,0);
  }

  &.--right {
    top: 0;
    bottom: 0;
    right: 0;
    &.--hidden {
      transform: translate3d(100%,0,0);
    }
  }

  &.--left {
    top: 0;
    bottom: 0;
    left: 0;
    &.--hidden {
      transform: translate3d(-100%,0,0);
    }
  }
  
  &.--top {
    top: 0;
    left: 0;
    right: 0;
    &.--hidden {
      transform: translate3d(0,-100%,0);
    }
  }

  &.--bottom {
    bottom: 0;
    right: 0;
    left: 0;
    &.--hidden {
      transform: translate3d(0,100%,0);
    }
  }

}